import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import logger from 'redux-logger'
import usersReducer from '@state/reducers/users'
import screensReducer from '@state/reducers/screens'
import dancesReducer from '@state/reducers/dances'
import songsReducer from '@state/reducers/songs'
import appReducer from '@state/reducers/app'
import logsReducer from '@state/reducers/logs'

const reducers = combineReducers({
    usersReducer,
    screensReducer,
    dancesReducer,
    songsReducer,
    appReducer,
    logsReducer,
})

export default createStore(
    reducers,
    applyMiddleware(
        thunk
        // logger
        // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    )
)
